import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link, AspectRatio, Text, Flex, Box, Container } from '@chakra-ui/react';
import SanityImage from 'gatsby-plugin-sanity-image';
import { ArrowForwardIcon } from '@chakra-ui/icons';

function ReadNext({ data }) {
  const { section, slug, title, hero } = data;
  return (
    <Container
      maxW='container.xl'
      borderTop='1px solid'
      borderBottom='px solid'
      borderColor='gray.300'
      pt={30}
      px={{ base: 0, xl: 60 }}
      as='section'
    >
      <Link
        to={`/${section === 'single' ? '' : `${section}/`}${slug.current}`}
        as={GatsbyLink}
        _hover={{
          textDecoration: 'none',
        }}
        data-group
        display='flex'
        flexDirection={{ base: 'column', xl: 'row' }}
        gap={{ base: 20, xl: 0 }}
        alignItems='center'
        px={{ base: 30, xl: 0 }}
      >
        <Flex
          flex={{ base: '0 0 100%', xl: '0 0 50%' }}
          width='100%'
          align='center'
          direction='column'
          gap={{ base: 20, xl: 60 }}
          alignItems='center'
          order={{ base: 2, xl: 1 }}
        >
          <AspectRatio ratio={{ base: 1.8, xl: 1.8 }} width='100%' overflow='hidden'>
            <Box
              transition='transform 1s ease-in-out'
              width='100%'
              height='100%'
              _groupHover={{
                transform: 'scale(1.1)',
              }}
            >
              <SanityImage
                {...hero.image}
                alt={hero?.image?.asset?.altText}
                width={690}
                height={383}
                hotspot={hero.image.hotspot}
                crop={hero.image.crop}
                style={{ height: '100%', width: '100%', objectFit: 'cover' }}
              />
            </Box>
          </AspectRatio>
        </Flex>
        <Flex
          flex='50%'
          direction='column'
          gap={10}
          px={{ base: 0, xl: 60 }}
          order={{ base: 1, xl: 2 }}
        >
          <Text
            textStyle='h3'
            textTransform='uppercase'
            transition='color 0.2s ease-in-out'
            flex='50%'
            _before={{
              content: '""',
              display: 'inline-block',
              width: '15px',
              height: '15px',
              marginRight: '10px',
              background: 'navy',
            }}
          >
            Read Next
          </Text>
          <Flex direction='row' gap={10} alignItems='center'>
            <Text textStyle='h2' transition='color 0.2s ease-in-out' flex='50%' color='navy'>
              {title}
            </Text>
            <ArrowForwardIcon
              _groupHover={{
                transform: 'translateX(10px)',
              }}
              transition='transform 1s ease-in-out'
              boxSize={8}
              color='navy'
            />
          </Flex>
          <Text textStyle='body' transition='color 0.2s ease-in-out' flex='50%' paddingRight={30}>
            {hero?.subtitle}
          </Text>
        </Flex>
      </Link>
    </Container>
  );
}

export default ReadNext;
